import Layout from "../components/Layout";
import { BillingBlotter } from "../components/_PaymentBillingBlotter/BillingBlotter";

const BillingBlotterPage = (props: any) => {
    return (
        <Layout>
            <BillingBlotter />
        </Layout>
    )
}

export default BillingBlotterPage